export enum OrderPlacementStatus {
    NotPlaced = 0,
    Queued = 1,
    Pending = 2,
    Failed = 3,
    Success = 4,
    Offline = 5
}
